// extracted by mini-css-extract-plugin
export default {"modalOverlay":"JD-z","modalContent":"KD-z","header":"LD-z","close":"MD-z"};